// extracted by mini-css-extract-plugin
export default {"optional":"src-views-editor-components-ExplanationPage-editable-EditableExplanationPage__optional--MToXD"};